/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Image from 'next/image';
import ImageGallery from 'react-image-gallery';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Divider from '@/components/UI/divider/Divider';
import Typography from '@/components/UI/typography/Typography';
import useBookmarkToggle from '@/hooks/useBookmark';
import styles from './TopSliderGalleryFullHeightDesktop.module.scss';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
type ITopSliderGalleryFullHeightDesktopProps = {
  handleClose: () => void;
  list: any[];
  clickedIndex?: number;
  title: string;
  id: number | string;
  setIsShareOpen: any;
};
const TopSliderGalleryFullHeightDesktop = ({
  handleClose,
  list,
  clickedIndex = 0,
  title,
  id,
  setIsShareOpen
}: ITopSliderGalleryFullHeightDesktopProps) => {
  const [images, setImages] = useState<any>([]);
  const [index, setIndex] = useState<number>(clickedIndex);
  const imageCount = list?.length;
  const handleSlide = (index: number) => setIndex(index);
  const {
    isBookmarked,
    toggleBookmark
  } = useBookmarkToggle(id);
  const isLogin = useSelector(state => state.bootstrapData?.data?.user_info?.uid);
  const isWhiteLabel = useIsWhiteLabel();
  useEffect(() => {
    setImages(list.map(item => ({
      original: item?.path || item?.hq_thumbnail_path || item?.thumbnail_path,
      thumbnail: item?.thumbnail_path || item?.hq_thumbnail_path,
      title: item?.title,
      originalAlt: item?.caption || item?.title,
      description: item?.caption
    })));
  }, [list]);
  const openShareHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    handleClose();
    setTimeout(() => {
      setIsShareOpen('SHARE');
    }, 400);
  };
  const bookmarkHandler = () => {
    if (isLogin) {
      toggleBookmark();
    } else {
      handleClose();
      toggleBookmark();
    }
  };
  return <Box className={styles['desktop-gallery']} data-sentry-element="Box" data-sentry-component="TopSliderGalleryFullHeightDesktop" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
      <Box className={styles['header-gallery-container']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
        <Box className={styles['right-content-container']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
          <Box className={styles['close-icon-container']} onClick={e => {
          e.stopPropagation();
          handleClose();
        }} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
            <Icon name="close" type="highEmphasis" size={24} data-sentry-element="Icon" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx" />
          </Box>
          <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">{title}</Typography>
        </Box>
        <Box className={styles['left-content-container']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
          <Box className={styles['icon-container']} onClick={bookmarkHandler} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
            <Icon name={isBookmarked ? 'heart-Filled' : 'heart'} type={isBookmarked ? 'error' : 'highEmphasis'} size={24} data-sentry-element="Icon" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx" />
          </Box>
          {!isWhiteLabel && <Box className={styles['icon-container']} onClick={openShareHandler}>
              <Icon name="share" type="highEmphasis" size={24} />
            </Box>}
        </Box>
      </Box>
      <Box className={styles['image-description-container']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
        <Box className={styles['image-description']} data-sentry-element="Box" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">
          <Typography variant="bodyS" data-sentry-element="Typography" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx">{`تصویر ${index + 1} از ${imageCount}`}</Typography>
          {images[index]?.title && <>
              <Divider orientation="vertical" />
              <Typography variant="bodyS">{images[index]?.title}</Typography>
            </>}
        </Box>
      </Box>
      <ImageGallery items={images} lazyLoad showNav isRTL onSlide={handleSlide} startIndex={clickedIndex} showPlayButton={false} showFullscreenButton={false} renderItem={(item: any) => {
      return <Box component={'figure'}>
              <Image className="image-gallery-image" src={item.original} alt={item.description || ''} width={800} height={500} layout="responsive" objectFit="contain" priority={false} />
            </Box>;
    }} renderLeftNav={(onClick: any) => <Box onClick={onClick} className={`${styles['arrow-container']} ${styles['arrow-left']}`}>
            <Icon name="arrow-left-1" type="highEmphasis" size={24} />
          </Box>} renderRightNav={(onClick: any) => <Box onClick={onClick} className={`${styles['arrow-container']} ${styles['arrow-right']}`}>
            <Icon name="arrow-right-2" type="highEmphasis" size={24} />
          </Box>} data-sentry-element="ImageGallery" data-sentry-source-file="TopSliderGalleryFullHeightDesktop.tsx" />
    </Box>;
};
export default TopSliderGalleryFullHeightDesktop;